import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsService } from '../../../../../../core/projects.service';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../../../../../../shared/services';

@Component({
    selector: 'app-submittals-tab-group',
    templateUrl: './submittals-tab-group.component.html',
    styleUrls: ['./submittals-tab-group.component.scss'],
    standalone: false
})
export class SubmittalsTabGroupComponent implements OnInit, OnDestroy {
  headersList: any[] = [
    {
      id: 0,
      label: 'Log',
      qp: 'list',
    },
    {
      id: 1,
      label: 'Registry',
      qp: 'registry',
    },
  ];
  selectedTabId = 0;
  selectedTabLabel: any;
  projectId: any;
  account: any;
  role: any;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private projectsService: ProjectsService,
    private authService: AuthService,
  ) {
  }

  ngOnInit() {
    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        if (qp.fs === undefined) {
          if (qp?.subTab) {
            this.selectedTabId = this.headersList.find(o => o?.qp === qp?.subTab)?.id || 0;
            if (this.headersList.find(o => o?.qp === qp?.subTab)?.id >= 4) {
              this.selectedTabLabel = this.headersList.find(o => o?.qp === qp?.subTab)?.label;
            }
          }
        }
      });

    this.route.params
      .pipe(takeUntil(this.onDestroy))
      .subscribe(p => {
        if (p.projectId) {
          this.projectId = p.projectId;

          this.account = this.authService.getCurrentUser();
          this.role = this.account.roles.find(obj => obj.project_id === this.projectId)?.role;

          if (!!this.role?.includes('reviewer')) {
            this.headersList = this.headersList.filter(obj =>
              ['Log'].includes(obj.label),
            );
          }
        }
      });
  }

  selectHeader(header) {
    this.projectsService.closeRightPanel.next();
    this.selectedTabId = header.id;
    this.selectedTabLabel = null;

    this.router.navigate([], {
      queryParams: {
        subTab: header.qp,
      },
      queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
